var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextBubble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09954 20.25L6.74514 19.1136C7.12252 18.853 7.58644 18.7897 8.01082 18.9409C9.06781 19.3175 10.2383 19.5136 11.5 19.5136C16.55 19.5136 21.5 17.1005 21.5 11.1318C21.5 5.16308 16.9143 2.5 11.5 2.5C6.08573 2.5 2.5 6.16308 2.5 11.1318C2.5 13.5254 3.35048 15.4279 4.89563 16.9851C5.26454 17.3569 5.43903 17.9057 5.36057 18.4475L5.09954 20.25ZM4.71762 23.2779C3.67253 23.9379 2.33688 23.0586 2.53019 21.8377L3.1622 17.846C1.44154 15.9905 0.5 13.5645 0.5 10.9408C0.5 4.9526 5.2655 0.5 12 0.5C18.7345 0.5 23.5 4.9526 23.5 10.9408C23.5 16.929 18.7345 21.3816 12 21.3816C10.745 21.3816 9.54842 21.2303 8.42901 20.9339L4.71762 23.2779Z",
    fill: "#B7B7B7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBubble);
export default __webpack_public_path__ + "static/media/text-bubble.0241f7c9abc43060cb03026f631ce275.svg";
export { ForwardRef as ReactComponent };